import { Component, EventEmitter, Input, OnChanges, OnInit, Optional, Output, SimpleChanges } from '@angular/core';
import { ControlValueAccessor, NgControl } from '@angular/forms';
import { SelectionItem } from 'src/app/shared/models/selectionItem';

import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { AlbertaIconModule } from '../../alberta-icon/alberta-icon.module';

interface Chip {
  value: any;
  displayText: string;
  isSelected: boolean;
}
@Component({
  standalone: true,
  selector: 'itl-chip-select',
  styleUrls: ['./chip-select.component.scss'],
  imports: [CommonModule, AlbertaIconModule, IonicModule],
  templateUrl: './chip-select.component.html',
})
export class ChipSelectComponent implements OnInit, OnChanges, ControlValueAccessor {
  @Input() public selectionItems: SelectionItem[];
  @Input() public selectableChips: Chip[] = [];
  @Input() public compareFn: any;
  @Input() public icon: string;
  @Input() public disabled: boolean;
  @Output() public change: EventEmitter<[]> = new EventEmitter<[]>();

  public values: any;
  private onChange = (text: string) => {};
  private onTouched = () => {};
  constructor(@Optional() public ngControl: NgControl) {
    if (this.ngControl) {
      ngControl.valueAccessor = this;
    }
  }

  public ngOnInit(): void {
    this.buildChips();
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if (changes['selectionItems'] || changes['compareFn']) {
      this.buildChips();
    }
  }

  public selectChip($event, item: Chip) {
    if (this.disabled) {
      return;
    }
    if (Array.isArray(this.values) && this.values.length > 0) {
      if (this.values.find(value => value === item.value) !== undefined) {
        // Item already selected. Remove value
        this.values = this.values.filter(value => value !== item.value);
      } else {
        // Item not yet select. Add value
        this.values.push(item.value);
      }
    } else {
      this.values = [item.value];
    }
    this.toggleChipSelection(item.value);

    this.updateChanges();
    this.change.emit(this.values);
    this.onTouched();
  }
  private toggleChipSelection(value: any) {
    this.selectableChips = this.selectableChips.map(chip => {
      if (chip.value === value) {
        chip.isSelected = !chip.isSelected;
      }
      return chip;
    });
  }

  private checkIfSelected(id: any): boolean {
    return (
      this.values &&
      this.values.find(item => {
        if (this.compareFn) {
          return this.compareFn(id, item);
        }
        return id === item;
      }) !== undefined
    );
  }

  private buildChips(): void {
    if (!this.selectionItems || !Array.isArray(this.selectionItems)) {
      this.selectableChips = [];
      return;
    }
    this.selectableChips = this.selectionItems.map(item => {
      return {
        value: item.id,
        displayText: item.value,
        isSelected: this.checkIfSelected(item.id),
      };
    });
  }

  public updateChanges() {
    this.onChange(this.values);
  }

  writeValue(obj: any) {
    this.values = obj;
    this.buildChips();
  }

  registerOnChange(fn: any): void {
    this.onChange = fn;
  }
  registerOnTouched(fn: any): void {
    this.onTouched = fn;
  }

  public discardSelection($event): void {
    if ($event) {
      $event.stopPropagation();
    }
    this.writeValue(null);
    this.onChange(this.values);
    this.change.emit(this.values);
  }
}
